(function (skyward, $, undefined)
{
    "use strict";

    var init = function (selector)
    {
        $(selector + " .selectorEEL").each(function (index)
        {
            //Find the necessary parts of the control
            var selectorEEL = $(this);
            var selectorInput = selectorEEL.find(".selectorEELInput"); //search textbox
            var selectorSearch = selectorEEL.find(".selectorEELSearch"); //search button

            //hidden values
            var selectorValue = selectorEEL.find(".selectorEELValue"); //hidden value
            var selectorData = selectorValue.data();
            var searchModule = selectorData.searchModule;
            var searchObject = selectorData.searchObject;
            var redirectModule = selectorData.redirectModule;
            var redirectObject = selectorData.redirectObject;
            var redirectScreen = selectorData.redirectScreen;
            var oldSelectorContent = "";
            var popupContent;
            var layer;

            skyward.eel.setFocusToTextBoxOnClick(selectorEEL);
            var keydownHandler = function (event)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
                var goUp = eventKeys.ARROW_LEFT || eventKeys.ARROW_UP;
                var goDown = eventKeys.ARROW_RIGHT || eventKeys.ARROW_DOWN;
                var goInto = eventKeys.ENTER;
                var exit = eventKeys.TAB;

                if ($.isEmptyObject(layer) || !layer.onscreen)
                {
                    if (goUp || goDown)
                    {
                        showSelectorPopup();
                    }
                }
                else if (goUp || goDown || goInto)
                {
                    var selectedRow = layer.contents.find(".templatedResult.selected");
                    if (selectedRow.length === 0)
                    {
                        return;
                    }

                    if (goUp || goDown) 
                    {
                        var nextRow;
                        if (goUp)
                        {
                            nextRow = selectedRow.prev();
                        }
                        else
                        {
                            nextRow = selectedRow.next();
                        }

                        updateSelectedRow(selectedRow, nextRow);
                        event.preventDefault();
                    }
                    else
                    {
                        selectedRow.click();
                    }
                }
                else if (exit)
                {
                    layer.close();
                }
            };

            var keyupHandler = function (event)
            {
                // Do not call if readonly or the contents haven't changed.
                if (!selectorInput.attr("readonly") && selectorInput.val() !== oldSelectorContent)
                {
                    oldSelectorContent = selectorInput.val();
                    if ($.isEmptyObject(layer) || !layer.onscreen)
                    {
                        showSelectorPopup();
                    }
                    else
                    {
                        getSelectorEELData();
                    }
                }
            };

            var clickHandler = function ()
            {
                skyward.window.loadContent("full", redirectModule, redirectObject, redirectScreen, $(this).data("key"));
            };

            var showSelectorPopup = function ()
            {
                if (selectorInput.attr("readonly"))
                {
                    return;
                }

                var body;
                var offset = selectorInput.offset();
                var height = selectorInput.outerHeight();
                var popupDivName = selectorInput.attr("id") + "_popup";
                var maxHeight = skyward.window.clientHeight * 0.85 - offset.top - height;

                popupContent = $("<div>",
                    {
                        id: popupDivName,
                        class: "verticalScroll popup anchored noAnchoredTail",
                        css:
                        {
                            maxHeight: skyward.global.mobileAccess ? "none" : maxHeight + "px",
                            left: offset.left,
                            top: offset.top + height
                        }
                    });
                popupContent.on("click", ".templatedResult:not(.ignoreClickEvent)", clickHandler);

                var modalLayerOptions =
                {
                    expose: [selectorInput.closest(".js-showEELContainer")],
                    popupAriaRole: "menu"
                };

                if (skyward.global.mobileAccess)
                {
                    body = $(document.body);
                    // the mobileEelOpen class will disable momentum scrolling, which causes issues with exposing elements through the glass
                    body.addClass('mobileEelOpen');

                    modalLayerOptions.afterClose = function ()
                    {
                        // reselect document.body
                        body.removeClass('mobileEelOpen');
                    };
                }

                layer = skyward.modalLayer.newModalLayer(popupContent, function ()
                {
                    popupContent = null;
                }, modalLayerOptions);

                getSelectorEELData();
                selectorInput.focus();
            };

            var lastRequest;
            //Get the templated information
            var getSelectorEELData = function ()
            {
                if (!$.isEmptyObject(lastRequest))
                {
                    lastRequest.abort();
                }

                lastRequest = $.ajax(
                    {
                        url: skyward.global.virtualDir + searchModule + "/" + searchObject + "/SelectorTemplate",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            seekText: skyward.extensions.encodeHtml(selectorInput.val())
                        },
                        success: function (data)
                        {
                            if ($.isEmptyObject(popupContent))
                            {
                                return;
                            }
                            
                            var popupContentElement = $(popupContent);

                            //Only do this if we have results
                            if (data.templatedResults.length > 0)
                            {
                                var contents = [];
                                var idPrefix = selectorValue.attr("id") + "-item-";

                                //Add the templated results to the div
                                for (var i = 0; i < data.templatedResults.length; i++)
                                {
                                    var id = idPrefix + data.templatedResults[i].Key;
                                    var labelId = id + "-label";
                                    var descriptionId = id + "-description";;

                                    var item = $("<div>",
                                        {
                                            id: id,
                                            class: "templatedResult selectorElementsCenter",
                                            "data-key": data.templatedResults[i].Key,
                                            html: data.templatedResults[i].Value,
                                            role: "menuitem"
                                        }
                                    );

                                    var labelArea = item.find(".js-labelArea");
                                    if (item.length)
                                    {
                                        labelArea.attr("id", labelId);
                                        item.attr("aria-labelledby", labelId);
                                    }

                                    var descriptionArea = item.find(".js-descriptionArea");
                                    if (descriptionArea.length)
                                    {
                                        descriptionArea.attr("id", descriptionId);
                                        item.attr("aria-describedby", descriptionId);
                                    }

                                    contents.push(item);
                                }
                                popupContentElement.empty().append(contents);

                                var selectedRow = popupContentElement.find(".templatedResult:first").addClass("selected");
                                selectorInput.attr("aria-activedescendant", selectedRow.addIds().attr("id"));

                                if (skyward.global.mobileAccess)
                                {
                                    calculateMobilePopupHeight();
                                }
                                else
                                {
                                    calculatePopupHeight(selectedRow);
                                }

                                skyward.window.notifyDOMLoad("#" + popupContentElement.attr("id"));
                            }
                            else
                            {
                                popupContentElement.empty().append($("<div>",
                                    {
                                        class: "noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter",
                                        html: "<p>No records to display</p>"
                                    })
                                );
                            }
                        }
                    });
            };

            var calculatePopupHeight = function (selectedRow)
            {
                if ($.isEmptyObject(popupContent))
                {
                    return;
                }

                var maxHeight = parseInt(popupContent.css("maxHeight"));
                var popupHeight = 0;
                var numberOfRecords = $(popupContent).children().length;
                var selectedRowHeight = selectedRow.outerHeight(true);
                if (numberOfRecords * selectedRowHeight > maxHeight)
                {
                    popupHeight = Math.floor(maxHeight / selectedRowHeight) * selectedRowHeight;
                }
                else
                {
                    popupHeight = numberOfRecords * selectedRowHeight;
                }

                popupContent.height(popupHeight);
            };

            var calculateMobilePopupHeight = function ()
            {
                if ($.isEmptyObject(popupContent))
                {
                    return;
                }

                var keyboardHeight = parseFloat($(document.body).attr("data-soft-keyboard-height")) || 0;

                popupContent.css(
                    {
                        maxHeight: skyward.window.clientHeight - popupContent.offset().top - keyboardHeight + "px"
                    });
            };

            var updateSelectedRow = function (selectedRow, nextRow)
            {
                if ($.isEmptyObject(nextRow) || nextRow.length === 0 || $.isEmptyObject(popupContent))
                {
                    return;
                }

                selectedRow.removeClass("selected");
                nextRow.addClass("selected");

                nextRow.scrollintoview(
                    {
                        duration: 0,
                        direction: "vertical",
                        viewPadding: { y: 0 }
                    });
                selectorInput.attr("aria-activedescendant", nextRow.addIds().attr("id"));
            };

            selectorInput.on('keydown', keydownHandler);
            selectorInput.debounce('keyup', keyupHandler);
            selectorSearch.on("click", function () 
            {
                if (layer != null && layer.onscreen && !skyward.global.mobileAccess) 
                {
                    layer.close();
                    return;
                }
                showSelectorPopup();
            });
            if (skyward.global.mobileAccess)
            {
                $(document.body).on("softKeyboardToggle", calculateMobilePopupHeight);
            }
        });
    };

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));